(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("hKys5", function(module, exports) {
var $cec1750578071086$var$reviews = document.querySelectorAll(".pd-reviews");
$cec1750578071086$var$reviews.forEach(function(review) {
    var loadMore = review.querySelector(".pd-reviews__link");
    loadMore === null || loadMore === void 0 || loadMore.addEventListener("click", function(e) {
        e.preventDefault();
        var title = loadMore.querySelector(".link__title");
        loadMore.classList.toggle("--open");
        review.classList.toggle("--open");
        var alternativeTitle = loadMore.dataset.alternativeTitle;
        if (!alternativeTitle) return;
        var tempTitle = title.innerText;
        title.innerText = alternativeTitle;
        loadMore.dataset.alternativeTitle = tempTitle;
    });
});

});

})();
//# sourceMappingURL=reviews.04b0e5c8.js.map
